// localeDisplayFonts.ts

import type { SupportedLocale } from "./locales";

type DisplayFontLoader = () => Promise<unknown>;

const loadNotoSansArabic: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-arabic/wght.css");
const loadNotoSansDevanagari: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-devanagari/wght.css");
const loadNotoSansJapanese: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-jp/wght.css");
const loadNotoSansKorean: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-kr/wght.css");
const loadNotoSansSimplifiedChinese: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-sc/wght.css");
const loadNotoSansTraditionalChinese: DisplayFontLoader = () =>
    import("@fontsource-variable/noto-sans-tc/wght.css");

const displayFontLoaderByLocale: Partial<
    Record<SupportedLocale, DisplayFontLoader>
> = {
    ar: loadNotoSansArabic,
    fa: loadNotoSansArabic,
    hi: loadNotoSansDevanagari,
    ja: loadNotoSansJapanese,
    ko: loadNotoSansKorean,
    "zh-Hans": loadNotoSansSimplifiedChinese,
    "zh-Hant": loadNotoSansTraditionalChinese,
};

const requestedDisplayFonts = new Set<DisplayFontLoader>();

export function loadLocaleDisplayFont(locale: SupportedLocale): void {
    const loader: DisplayFontLoader | undefined =
        displayFontLoaderByLocale[locale];
    if (!loader || requestedDisplayFonts.has(loader)) return;

    requestedDisplayFonts.add(loader);
    void loader().catch((error: unknown) => {
        requestedDisplayFonts.delete(loader);
        console.error(
            `[Typography] Could not load the ${locale} display font`,
            error,
        );
    });
}
